define(["marionette", "./template/advancedConfigurationTemplate.html"], function (
  Marionette,
  AdvancedConfigurationTemplate,
) {
  "use strict";

  return {
    layout: Marionette.Layout.extend({
      template: AdvancedConfigurationTemplate,
      regions: {
        list: "#advancedConfigurationList",
      },
    }),
  };
});
